import { ContentType, request } from "../api";
import { baseParams } from "../common";

export const rechargeBalance = async (data = {}, params = {}) => request({
  path: "/add-balance",
  method: "POST",
  body: { ...baseParams, ...data },
  type: ContentType.Json,
  format: "json",
  secure: true,
  ...params,
});
